module.exports = __webpack_public_path__ + "img/cityPartner4.fc2f05c5.png";